export default from './ProjectMappings';



// WEBPACK FOOTER //
// ./src/containers/ProjectMappings/index.js